import React from 'react';
import { Link } from 'react-router-dom';
import logoImage from '../assets/images/faire_logo.png';

const Header = () => {
  return (
    <header data-wf--navbar-main--variant="base" className="navbar_wrap">
      <div className="navbar_contain u-grid-custom">
        <div id="w-node-_26288226-3bdd-0809-6cc1-73fcc9effc4b-c9effc49" className="navbar_left_wrap">
          <Link to="/" aria-label="Return to home" className="navbar_home w-inline-block">
            <div data-split-text="" className="navbar_home_text u-text-h3">
              {logoImage && (
                <img src={logoImage} alt="" className="w-[150px] md:w-[250px]"/>
              )}
            </div>
          </Link>
        </div>
        <div id="w-node-_26288226-3bdd-0809-6cc1-73fcc9effc4f-c9effc49" className="navbar_aside_wrap">
          <nav className="navbar_links">
            <ul className="navbar_links_ul u-gap-small u-hflex-left-center">
              <li className="navbar_links_li is-works">
                <Link data-link-hover="" data-wf--link-block--variant="base" to="/works" className="g_link u-text-small w-inline-block">
                  <div className="g_link_contain">
                    <div data-link="" className="g_link_text">Works</div>
                  </div>
                </Link>
                <div className="g_comma"></div>
              </li>
              <li className="navbar_links_li">
                <Link data-link-hover="" data-wf--link-block--variant="base" to="/studio" className="g_link u-text-small w-inline-block">
                  <div className="g_link_contain">
                    <div data-link="" className="g_link_text">About</div>
                  </div>
                </Link>
                <div className="g_comma"></div>
              </li>
              <li className="navbar_links_li">
                <Link data-link-hover="" data-wf--link-block--variant="base" to="/process" className="g_link u-text-small w-inline-block">
                  <div className="g_link_contain">
                    <div data-link="" className="g_link_text">Process</div>
                  </div>
                </Link>
                <div className="g_comma"></div>
              </li>             
            </ul>
          </nav>
        </div>
        <div id="w-node-_26288226-3bdd-0809-6cc1-73fcc9effc69-c9effc49" className="navbar_cta_wrap">
          <div className="navbar_cta_contain">
            <button type="button" data-wf--btn-contact--variant="base" data-link-hover="" data-contact-btn="" className="btn_default_wrap">
              <div className="btn_default_contain">
                <div data-link="" className="btn_default_text">상담신청</div>
              </div>
              <div className="g_circle is-light"></div>
            </button>
          </div>
          <button data-menu-btn="" className="navbar_menu_btn">
            <div className="navbar_menu_text u-text-small">MENU</div>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;